/**
 * True when an HTML segment has a <p> at the top level, i.e. one the
 * `.prose-lede-host > p:first-of-type` selector can reach. The renderer uses
 * this to pick which segment hosts the editorial lede after widget markers
 * split the body; a segment holding only a Fast Answer box (its <p> is inside
 * the wrapper div) has no such paragraph, and neither does one whose only
 * paragraphs sit inside a table, list, or blockquote.
 *
 * Depth is tracked per element, not just per <div>, so wrappers of any kind
 * count. Void elements never change depth.
 */
const VOID = new Set(['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'source', 'track', 'wbr'])
const TAG_RE = /<\/?([a-zA-Z][a-zA-Z0-9-]*)\b[^>]*?>/g

export function hasLedeParagraph(html: string): boolean {
  let depth = 0
  let m: RegExpExecArray | null
  TAG_RE.lastIndex = 0
  while ((m = TAG_RE.exec(html)) !== null) {
    const tag = m[1].toLowerCase()
    const isClose = m[0].startsWith('</')
    const selfClosing = m[0].endsWith('/>') || VOID.has(tag)
    if (isClose) {
      depth = Math.max(0, depth - 1)
      continue
    }
    if (tag === 'p' && depth === 0) return true
    if (!selfClosing) depth++
  }
  return false
}
